
<template>
  <div class="mathPackage">
      <div class="mathPackageArea">
          <img @click="close" class="banner" src="../assets/image/1.png" alt=""/>
          <img @click="close" class="banner" src="../assets/image/2.png" alt=""/>
          <img class="banner" @click="trySeeVideo" src="../assets/image/3.png" alt=""/>
          <img @click="close" class="banner service"  src="../assets/image/4.png" alt=""/>
          <!-- 底部区域-->
          <footer>
                <div  class="contactServiceArea">
                    <div class="priceArea">
                        <div v-if="!select" @click="showPackage" class="superValue">￥</div>
                        <div v-if="select"  class="superValue">￥</div>
                        <div v-if="!select" @click="showPackage" class="price">{{price}}</div>
                        <div v-if="select"  class="price">{{price}}</div>
                        <div v-if="select" class="year">元起</div>
                        <div @click="showPackage" v-if="!select" class="year">元</div>
                    </div>
                    <div v-if="select"  class="expiry_date">有效期:{{expiry_date}}</div>
                    <div @click="showPackage" v-if="!select"  class="expiry_date">有效期:{{expiry_date}}</div>
                </div>
                <div class="priceIndate">
                <img src="../assets/image/pic_middle.png" alt=""/>
                </div>
                <div v-if="!packageselect" class="discountBuy"   @click="immediatelyBuy">
                    <img src="../assets/image/pic_right.png" alt=""/>
                </div>
                <div v-if="packageselect" class="discountBuy"   @click="showPackage">
                    <img src="../assets/image/pic_right.png" alt=""/>
                </div>
         </footer>
         <!-- 套餐选择区域 -->
         <div v-if="packageSelectArea" class="packageSelectArea">
             <img @click="close" class="icon_close" src="../assets/image/icon_close.png" alt="">
             <div class="packageTitle">请选择购买的套餐类型</div>
             <div v-for="item in package" :key="item.id" @click="selectPackage(item.id,item.price)" :class="selectedId == item.id ? 'selectColor': ''" class="packages">
                 <div class="thePackagesTitle" :class="selectedId == item.id ? 'selectColor': ''">{{item.title}}</div>
                 <div class="thePackagesTitlePrice" :class="selectedId == item.id ? 'selectColor': ''">￥{{item.price}}</div>
             </div>
         </div>

          <!-- 试听课程的视频进行弹框-->
          <!-- 用来放播放的视频的div-->
          <div id="isShowMaskVideo" class="isShowMaskVideo" v-show="isShowMaskVideo">
              <!-- 关闭按钮的x号-->
          <span class="closeVideo" @click="destroy()">
              <img src="../assets/image/icon_fork.png" alt=""/>
          </span>
              <div  id="player">

              </div>
          </div>
         
      </div>
  </div>
</template>

<script>
    import videoPlay from "@/global"
export default {
  name: 'promoters',
  data () {
    return {
         token:null,//保利的视频token
         ts:null,//保利视频的ts
         sign:null,//保利的视频sign
         isShowMaskVideo:false,//视频的弹框默认是关闭的
         pl_id:"",
         price:'',
         expiry_date:'',
         select:true,//默认是true
         packageselect:true,
         packageSelectArea:false,//套餐选择区域是否显示
         package:[],
         selectedId:null,//选中的id 
    }
  },
    mounted(){
         this.getLowerPrice();
         this.mathList();
    },

   methods:{
       //获取最低价格
       getLowerPrice(){
           var that = this;
           var url = "mobile/package/math"
           that.axios.get(url).then((res)=>{
               that.sign = res.data.data.sign;
               that.ts = res.data.data.ts;
               that.token = res.data.data.token;
               that.pl_id = res.data.data.pl_id;
               that.price = res.data.data.lower_price;
               that.title = res.data.data.title;
               document.title = that.title;
           }).catch((err)=>{

           })
       },
       //获取套餐列表
       mathList(){
           var that = this;
           var url = "mobile/package/mathList"
           that.axios.get(url).then((res)=>{
               that.package = res.data.data;
               that.expiry_date = that.package[0].expiry_date;   
           }).catch((err)=>{

           })
       },
       //点击课程试听进行视频播放
       trySeeVideo(){
           //       封装一个方法，用来播放视频
           const that = this;
           this.isShowMaskVideo = true;
           videoPlay.player = polyvPlayer({
               wrap: '#player',
               width:"100%",
               height: "100%",
               "vid": that.pl_id,
               playsafe:that.token,
//               "vid": "d15b750dc1362b7489c58f10ed2aae3f_d",
//               playsafe:"310be44b73f7c622994248af9264a0217589b025",
               'forceH5': true,
               ts:that.ts,//保利的ts
               sign:that.sign,//保利的sign
               skinLocation:1,//默认是1
//                    autoplay:true,
               screenshot:true,//开启视频截图
//                  skinLocation:0
           });
       },
       //       关闭遮罩层
       destroy(){
           this.isShowMaskVideo = false;
           videoPlay.player.destroy();
       },
       showPackage(){
           var that = this;
           that.packageSelectArea = true;
       },
       close(){
           var that = this;
           that.packageSelectArea = false; 
       },
       selectPackage(e,f){
           this.selectedId = e;
           this.price = f;
           this.packageselect = false;
           this.select = false;
       },
       //封装一个方法用来判断是安卓还是ios
       isAndroid_ios(){
           var u = navigator.userAgent, app = navigator.appVersion;
           var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
           var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
           return isAndroid==true?true:false;
       },
       immediatelyBuy(){
           //调用安卓和ios的方法和客户端进行交互
           const that = this;
           that.packageSelectArea = false;
           if(that.isAndroid_ios()){
//        调用安卓的方法给安卓发送数据 传给安卓的数据能是对象和null，不然安卓拿不到数据
               window.android.goBuy(that.selectedId)//goBuy是安卓的方法
           }else{
//           调用ios的方法给ios发送数据，如果不需要传数据，那就传null，千万不能不传，不然ios收不到值
               window.webkit.messageHandlers.goBuy.postMessage(that.selectedId);//goBuy是ios的方法
           }
       }

   }
}
</script>
<style>
    /*在ios下用看到的数据除以30，得到的数据加上rem*/
    .mathPackage .mathPackageArea{
        position: relative;
    }
    .mathPackage .mathPackageArea .banner{
        width: 100%;
        height: auto;
    }
    .mathPackage .mathPackageArea .banner.service{
        margin-bottom: 0rem;
    }
    .mathPackage .packageSelectArea{
        width: 100%;
        height: 14.5rem;
        background: #FFFFFF;
        position: fixed;
        left: 0;
        bottom: 2rem;
    }
    /* icon_close */
    .mathPackage .packageSelectArea .icon_close{
        width: .933333rem;
        height: .933333remrem;
        position: absolute;
        right: 0;
        top: 0rem;
    }
    /* packageTitle */
    .mathPackage .packageSelectArea .packageTitle{
        font-size: .5rem;
        color: #270400;
        font-family:Source Han Sans SC;
        font-weight:600;
        width: 100%;
        text-align: center;
        margin-top: .96663rem;
        margin-bottom: .2667rem;
    }
    /* packages */
   .mathPackage .packageSelectArea .packages{
        width: 89%;
        margin-left: 5.5%;
        background: #E5EBFF;
        display: flex;
        justify-content: space-around;
        justify-content: space-between;
        margin-top: .4rem;
        border-radius: 8px;
        height: 1.6rem;
    }
    .mathPackage .packageSelectArea .packages .thePackagesTitle{
        font-size: .5rem;
        color: #270400;
        font-family:Source Han Sans SC;
        font-weight:600;
        display: flex;
        align-items: center;
        margin-left: 8.5%;
    }
    .mathPackage .packageSelectArea .packages .thePackagesTitlePrice{
        color: #EB1300;
        font-size: .6rem;
        font-family:Source Han Sans SC;
        font-weight:600;
        display: flex;
        align-items: center;
        margin-right: 8.5%;
    }
    .mathPackage .packageSelectArea .packages.selectColor{
        background-color: #FF5F00!important;
        color: #FFFFFF!important;
    }
    .mathPackage .packageSelectArea .packages .thePackagesTitle.selectColor{
        background-color: #FF5F00!important;
        color: #FFFFFF!important;
    }
   .mathPackage .packageSelectArea .packages .thePackagesTitlePrice.selectColor{
        background-color: #FF5F00!important;
        color: #FFFFFF!important;
    }
   .mathPackage footer{
        width: 100%;
        height: 2rem;
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        position: fixed;
        left: 0;
        bottom: 0;
    }
    .mathPackage footer .contactServiceArea{
        display: flex;
        height: 1.95rem;
        width: 55.3%;
        align-items: center;
        background:linear-gradient(0deg,#FFAE01,#FFE401);
        border-top: .05rem solid #b1bff2;
    }
    .mathPackage footer .contactServiceArea .priceArea{
        height: 2rem;
        display: flex;
        align-items: center;
    }
    /* superValue */
    .mathPackage footer .contactServiceArea .priceArea .superValue{
        color: #270400;
        font-size: .5rem;
        font-family:Source Han Sans SC;
        font-weight:600;
        height: 2rem;
        margin-left: .65rem;
        margin-top: 1.5rem;
        white-space:nowrap;
    }
   /*price  */
    .mathPackage footer .contactServiceArea .priceArea .price{
        color: #270400;
        font-size: .9333rem;
        font-family:Source Han Sans SC;
        font-weight:500;
        height: 2rem;
        display: flex;
        align-items: center;
        white-space:nowrap;
    }
    /* year */
    .mathPackage footer .contactServiceArea .priceArea .year{
        color: #270400;
        font-size: .5rem;
        font-family:Source Han Sans SC;
        font-weight:600;
        width: 30%;
        white-space:nowrap;
        margin-top: .2333rem;
        margin-left: .2rem;
    }
    /* expiry_date */
    .mathPackage footer .contactServiceArea .expiry_date{
        color: #270400;
        font-size: .366667rem;
        font-family:Source Han Sans SC;
        font-weight:600;
        margin-top: .35rem;
        margin-left: .38rem;
    }
    .mathPackage footer .verticalline{
        width: 1px;
        height: 0.9rem;
        background-color: #B8B8B8;
    }
    .mathPackage footer .priceIndate{
        display: flex;
        flex-direction: column;
        height: 2rem;
        justify-content: center;
        align-items: center;
        width: 6.6%;
    }
    .mathPackage footer .priceIndate img{
        width: 100%;
        height: 100%;
    }
    .mathPackage footer .yprice{
        height: 1.8rem;
        width: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .mathPackage footer .yprice .ypriceText{
        color: #333333;
        font-size:.5rem;
        font-family:PingFang SC;
        font-weight:500;
        text-decoration: line-through;
    }
    .mathPackage footer .yprice .indate{
        font-size:.26667rem;
        font-family:PingFang SC;
        font-weight:400;
        color:#343434;
    }
    .mathPackage footer .discountBuy{
        display: flex;
        flex-direction: column;
        height: 2rem;
        width: 38.1%;
        justify-content: center;
        align-items: center;
    }
    .mathPackage footer .discountBuy img{
        width: 100%;
        height: 100%;
    }

    /*视频播放开始*/
    /*player用来放播放的视频的div*/
    #player{
        width: 100% !important;
        height: 6rem !important;
        position: fixed;
        top: 50%;
        transform: translatey(-50%);
    }
    /*遮罩层*/
    .isShowMaskVideo{
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        bottom: 0px;
        background-color: rgba(0, 0, 0, .7);
        z-index: 10000;
    }
    .isShowMaskVideo .closeVideo{
        color: #ffffff;
        float: right;
        margin-top: .5rem;
        margin-right: .5rem;
        width: .8rem;
        height: .8rem;
    }
    .isShowMaskVideo .closeVideo img{
        width: .8rem;
        height: .8rem;
    }
    /*视频播放结束*/

</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue